import type { FC } from 'react'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'

interface IDocumentTitleProps {
  children?: React.ReactNode
  title?: string
  faviconUrl?: string
}

let defaultFaviconHref: string | null = null

export const DocumentTitle: FC<IDocumentTitleProps> = ({ children, title, faviconUrl }) => {
  useEffect(() => {
    let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']")

    if (defaultFaviconHref === null && link) {
      defaultFaviconHref = link.href
    }

    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
      if (defaultFaviconHref) {
        link.href = defaultFaviconHref
      }
    }

    let targetHref: string

    if (faviconUrl) {
      targetHref = faviconUrl
    } else {
      targetHref = defaultFaviconHref || '/favicon.ico'
    }

    const currentAbsoluteHref = new URL(link.href, window.location.origin).href
    const targetAbsoluteHref = new URL(targetHref, window.location.origin).href

    if (currentAbsoluteHref !== targetAbsoluteHref) {
      link.href = targetHref
    }
  }, [faviconUrl])

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </>
  )
}
export default DocumentTitle
